import { render } from "./SelectObjectList.vue?vue&type=template&id=c23b3c8a"
import script from "./SelectObjectList.vue?vue&type=script&lang=js"
export * from "./SelectObjectList.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__